<template>
  <div class="form-content">
    <div class="label-heading label-heading-active">
      <h4>{{ translationText.text.payment }}</h4>
      <!-- <a href="javascript: ;" class="link">Edit</a> -->
    </div>

    <div class="form-infomation">
      <div class="options-highlited">
        {{ translationText.text.paymentSsl }}
        <i class="ri-shield-keyhole-line"></i>
      </div>
        <div v-if="showCheckoutMsg" class="options-highlited options-highlited-msg">
          Try it for 60 days and see visible results or get 100% of your money back.
          No returns required. Simply email our support team, and we'll issue an instant refund.
        </div>

    </div>
    <div class="form-input">
      <div class="payment-information" id="sector_descriptions">
        <div class="payment-options payment-options-new">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="sector"
              id="cards_sector"
              value="stripe"
               v-model="selectedPaymentMethod"
              
            />
            <label class="form-check-label" for="cards_sector">
              <img src="/assets/images/checkout/payment-small.png" alt="PayPal" />
            </label>
            <!--<img src="/assets/images/crdit-debit.jpg" alt="" class="cards" />-->
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="paymentMethod"
              id="paypal_radio"
              value="paypal"
              v-model="selectedPaymentMethod"
            />
            <label class="form-check-label" for="paypal_radio">
              <img src="/assets/images/checkout/Paypal_checkout.png?ver=1.0.0" alt="PayPal" />
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="paymentMethod"
              id="gpay_radio"
              value="gpay"
              v-model="selectedPaymentMethod"
            />
            <label class="form-check-label" for="gpay_radio">
              <img src="/assets/images/checkout/gpay_checkout.png?ver=1.0.0" alt="G Pay" />
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="paymentMethod"
              id="apay_radio"
              value="apple Pay"
              v-model="selectedPaymentMethod"
            />
            <label class="form-check-label" for="apay_radio">
              <img src="/assets/images/checkout/applepay_checkout.png?ver=1.0.0" alt="Apple Pay" />
            </label>
          </div>
        </div>
        
       

        <div class="payment-method">
          <div class="row row-flex payment-element">
            <StripeElements
              v-if="stripeLoaded && selectedPaymentMethod === 'stripe'"
              v-slot="{ elements, instance }"
              ref="elms"
              :stripe-key="stripeKey"
              :instance-options="instanceOptions"
              :elements-options="elementsOptions"
            >
              <div class="col-12 form-group">
                <label>{{ translationText.text.cardNumber }}</label>
                <div class="input-icon">
                  <StripeElement
                    ref="card"
                    type="cardNumber"
                    :elements="elements"
                    :options="cardNumberOptions"
                  />
                 <!--<img src="/assets/images/checkout/stripe_cards.png" alt="" class="stripeicon" /> -->
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="">{{ translationText.text.expiration }}</label>
                  <StripeElement
                    ref="card"
                    type="cardExpiry"
                    :elements="elements"
                    :options="cardExpiryOptions"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for=""
                    >{{ translationText.text.cvv }}
                    {{ paymentParentNextBtn }}</label
                  >
                  <div class="input-icon">
                    <StripeElement
                      ref="card"
                      type="cardCvc"
                      :elements="elements"
                      :options="cardCvcOptions"
                    />
                  </div>
                </div>
              </div>
            </StripeElements>
            <!-- Paypal Button -->
            <div v-if="selectedPaymentMethod === 'paypal'" id="paypal-button-container"></div>
            <p v-if="(paypalPaymentUnavailable || paypalAutoshipPaymentUnavailable) && (selectedPaymentMethod === 'paypal')" class="alert alert-warning">
              <strong>
                <span v-if="paypalPaymentUnavailable">
                  Please complete all the required delivery address fields before continuing.
                 </span>
                 <span v-if="paypalAutoshipPaymentUnavailable">
                  Paypal does not support Autoship order for now. Pleae remove autoship product from the order
                 </span>
              </strong>
            </p>          

            <!-- Gpay and Apple Pay Button-->
            <div v-if="selectedPaymentMethod === 'gpay' || selectedPaymentMethod === 'apple Pay'">
              <div id="payment-request-button" :style="{ display: paymentUnavailable ? 'none' : 'block' }"></div>
            </div>
            <p v-if="paymentUnavailable && (selectedPaymentMethod === 'gpay' || selectedPaymentMethod === 'apple Pay')" class="alert alert-warning">
              <strong>
                <span v-if="selectedPaymentMethod === 'gpay'">
                  Google Pay is not available. Make sure you're signed into Chrome with a valid card set up at
                  <a href="https://pay.google.com" target="_blank">pay.google.com</a>.
                </span>
                <span v-else-if="selectedPaymentMethod === 'apple Pay'">
                  Apple Pay is not available. Please use Safari on a supported Apple device with a Wallet card configured.
                </span>
              </strong>
            </p>
            <p v-if="(gPayaPayShippingPaymentUnavailable || gPayaPayAutoshipPaymentUnavailable)  && (selectedPaymentMethod === 'gpay' || selectedPaymentMethod === 'apple Pay')" class="alert alert-warning">
              <strong>
                <span v-if="gPayaPayShippingPaymentUnavailable">
                  Please complete all the required delivery address fields before continuing.
                 </span>
                 <span v-if="gPayaPayAutoshipPaymentUnavailable">
                  GPay/Apple Pay does not support Autoship order for now. Pleae remove autoship product from the order
                 </span>
              </strong>
            </p>           
          </div>
        </div>      
      </div>
    </div>
  </div>
  <button v-if="selectedPaymentMethod === 'stripe'"
    @click="pay"
    type="button"
    class="btn rc btn-dark"
    value="Place Order"
  >
    {{ translationText.text.placeOrder }}
    <i class="ri-arrow-right-line"></i>
  </button>

  <!-- Payment Processing Overlay -->
  <div v-if="isProcessingPayment" class="payment-processing-overlay">
    <div class="payment-processing-content">
      <div class="spinner"></div>
      <h3>Processing Your Payment...</h3>
      <p class="warning-message">
        <i class="ri-alert-line"></i>
        Please do not click Back, Refresh, or close this browser window while your order is being processed.
      </p>
    </div>
  </div>

</template>
<script>
import { StripeElements, StripeElement, createElement } from "vue-stripe-js";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
  defineEmits  
} from "vue";
import { useLoginStore } from "../../stores/login";
import { userLanguage } from "../../stores/language";
import { useRouter, useRoute } from "vue-router";
import { useCartStore } from "../../stores/cart";



export default defineComponent({
  name: "CardOnly",
  //props: ["paymentParentNextBtn", "translationText"],
  components: {
    StripeElements,
    StripeElement,
    createElement,
  },
  //const router = useRouter();

  props: [
    "paymentParentNextBtn",
    "translationText",
    "email",
    "password",
    "country",
    "first_name",
    "last_name",
    "address1",
    "addres2",
    "city",
    "state",
    "zip_code",
    "mobile",
    "billing_country",
    "billing_first_name",
    "billing_last_name",
    "billing_address1",
    "billing_addres2",
    "billing_city",
    "billing_state",
    "billing_zip_code",
    "billing_mobile",
    "billSame",
    "stayup",
    "terms",
    "shippingType",
    "baseURL",
    "shippingTypeName"
  ],
  data() {
    return {
      paymentBtn: false,
      //bar: { name: "hi" }
    };
  },

  setup(props) {
    console.log(props);
    const paymentUnavailable = ref(false);
    const paypalPaymentUnavailable = ref(false);
    const paypalAutoshipPaymentUnavailable = ref(false);
    const gPayaPayAutoshipPaymentUnavailable = ref(false);
    const gPayaPayShippingPaymentUnavailable = ref(false);
    const paymentBtn = ref(false);
    const isProcessingPayment = ref(false); // Payment processing overlay state
    const stripeKey = ref(`${process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY}`); // test key
    const instanceOptions = ref({
      // https://stripe.com/docs/js/initializing#init_stripe_js-options
    });
    const elementsOptions = ref({
      // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
    });
    const cardOptions = ref({
      // https://stripe.com/docs/stripe.js#element-options
      value: {
        postalCode: "12345",
      },
    });

    // CVV/CVC options - allows 4 digits for AMEX and shows CVV placeholder
    const cardCvcOptions = ref({
      placeholder: '****',
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    });

    // Card number options
    const cardNumberOptions = ref({
      placeholder: '1234 1234 1234 1234',
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    });

    // Card expiry options
    const cardExpiryOptions = ref({
      placeholder: 'MM / YY',
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    });
    const userLogin = useLoginStore();
    const router = useRouter();
    const route = useRoute();
    const stripeLoaded = ref(false);
    const selectedPaymentMethod = ref("stripe");

    const card = ref();
    const elms = ref();
    const cardNumber = ref();
    const cardExpiry = ref();
    const cardCvc = ref();
    const cartData = useCartStore();
    const userLanguages = userLanguage();
    const stripe = ref(null);
    const showCheckoutMsg = ref(false);
    

    onMounted(() => {
      loadStripe(stripeKey.value).then((sdk) => {
        stripe.value = sdk;
        stripeLoaded.value = true;
      });
      const productParam = route.query.product;
      if (productParam == '16' || productParam == 16) {
        showCheckoutMsg.value = true;
      }

      // Load PayPal SDK only if not already loaded by UnifiedExpressCheckout
      // UnifiedExpressCheckout loads first with geolocation-detected currency
      if (!window.paypal && !document.querySelector('script[src*="paypal.com/sdk/js"]')) {
        const paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID;
        const scriptId = "paypal-sdk";
        const currencySymb = props.country == 38 ? "CAD" : "USD";

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=${currencySymb}&components=buttons&intent=capture`;
        script.async = true;
        script.onload = () => {
          console.log("PayPal SDK Loaded");
        };
        document.head.appendChild(script);
      } else {
        console.log("PayPal SDK already loaded (likely by UnifiedExpressCheckout)");
      }
    });

    watch(selectedPaymentMethod, (newValue) => {

        if (newValue === 'paypal') {
          // Check for autoship products (PayPal doesn't support autoship)
          if (!isAutoshipProductExist()) {
            paypalAutoshipPaymentUnavailable.value = true;
            return false;
          }

          nextTick(() => {
            console.log("paypal1", newValue);
            if (window.paypal && typeof window.paypal.Buttons === 'function') {
              renderPayPalButton();
              console.log("paypal2", newValue);
              paypalAutoshipPaymentUnavailable.value = false;
              paypalPaymentUnavailable.value = false;
            } else {
              console.error('PayPal SDK not yet ready.');
            }
          });
        }
        if (newValue === 'gpay' || newValue === 'apple Pay') {
          nextTick(() => {
            const el = document.getElementById('payment-request-button');
            if (el) el.innerHTML = ''; // Clear old buttons
            maybeSetupPaymentRequest();
          });
        }
    });

    const loadPaypalScript = () => {
        const paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID;
        const scriptId = "paypal-sdk";
      console.error("Ppaypal-sdk1");
        if (!document.getElementById(scriptId)) {
          const script = document.createElement("script");
          const currencySymb = (props.country == 38) ? "CAD" : "USD";
          script.id = scriptId;
          script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientId}&currency=${currencySymb}&components=buttons&intent=capture`;
          script.async = true;
          script.onload = () => renderPayPalButton();
          script.onerror = () => console.error("Failed to load PayPal SDK script.");
          document.head.appendChild(script);
        } else {
          renderPayPalButton();
        }
    };

    const renderPayPalButton = () => {
      console.log("🔘 [REGULAR_PAYPAL] Rendering PayPal button...");
      nextTick(() => {
        const container = document.getElementById("paypal-button-container");
        if (!container) {
          console.error("❌ [REGULAR_PAYPAL] PayPal container not found");
          return;
        }
        console.log("✅ [REGULAR_PAYPAL] PayPal container found, clearing old buttons");
        container.innerHTML = ""; // Clear previous buttons if any

        if (window.paypal && typeof window.paypal.Buttons === "function") {
          console.log("✅ [REGULAR_PAYPAL] PayPal SDK loaded, initializing buttons");

          window.paypal.Buttons({
            style: {
              shape: 'rect',
              color: 'gold',
              layout: 'vertical',
              label: 'paypal',
              height: 50
            },

            createOrder: (data, actions) => {
              console.log("💳 [REGULAR_PAYPAL_CREATE] === CREATING PAYPAL ORDER ===");
              console.log("💳 [REGULAR_PAYPAL_CREATE] Timestamp:", new Date().toISOString());
              console.log("💳 [REGULAR_PAYPAL_CREATE] Cart total:", cartData.getCartTotalNetPrice);
              console.log("💳 [REGULAR_PAYPAL_CREATE] Currency:", props.country == 38 ? "CAD" : "USD");

              const orderAmount = Number(cartData.getCartTotalNetPrice).toFixed(2);
              console.log("💳 [REGULAR_PAYPAL_CREATE] Order amount:", orderAmount);

              // Build items array for PayPal
              const items = cartData.getCheckoutCartProducts.map(product => ({
                name: product.name || `Product ${product.id}`,
                unit_amount: {
                  currency_code: props.country == 38 ? "CAD" : "USD",
                  value: Number(product.sale_price || product.price).toFixed(2)
                },
                quantity: product.quantity || 1
              }));

              // Calculate item total
              const itemTotal = items.reduce((sum, item) => {
                return sum + (parseFloat(item.unit_amount.value) * item.quantity);
              }, 0).toFixed(2);

              console.log("💳 [REGULAR_PAYPAL_CREATE] Items:", items);
              console.log("💳 [REGULAR_PAYPAL_CREATE] Item total:", itemTotal);

              return actions.order.create({
                purchase_units: [{
                  amount: {
                    currency_code: props.country == 38 ? "CAD" : "USD",
                    value: orderAmount,
                    breakdown: {
                      item_total: {
                        currency_code: props.country == 38 ? "CAD" : "USD",
                        value: itemTotal
                      }
                    }
                  },
                  items: items
                }],
                application_context: {
                  shipping_preference: 'GET_FROM_FILE' // Collect shipping address from PayPal
                }
              });
            },

            onApprove: async (data, actions) => {
              console.log("🎉 [REGULAR_PAYPAL_APPROVE] === CUSTOMER APPROVED PAYMENT ===");
              console.log("🎉 [REGULAR_PAYPAL_APPROVE] Timestamp:", new Date().toISOString());
              console.log("🎉 [REGULAR_PAYPAL_APPROVE] PayPal Order ID:", data.orderID);
              console.log("🎉 [REGULAR_PAYPAL_APPROVE] Payer ID:", data.payerID);

              try {
                console.log("💰 [REGULAR_PAYPAL_APPROVE] Capturing PayPal payment...");
                const captureStartTime = Date.now();
                const order = await actions.order.capture();
                const captureDuration = Date.now() - captureStartTime;

                console.log("✅ [REGULAR_PAYPAL_APPROVE] PayPal payment captured successfully!");
                console.log("✅ [REGULAR_PAYPAL_APPROVE] Capture took:", captureDuration, "ms");
                console.log("✅ [REGULAR_PAYPAL_APPROVE] Captured order:", order);
                console.log("✅ [REGULAR_PAYPAL_APPROVE] PayPal Transaction ID:", order.id);

                // Extract shipping address from PayPal response
                const shippingAddress = order.purchase_units[0]?.shipping?.address || {};
                const payerInfo = order.payer || {};
                console.log("📦 [REGULAR_PAYPAL_APPROVE] Shipping Address:", shippingAddress);
                console.log("📦 [REGULAR_PAYPAL_APPROVE] Payer Info:", payerInfo);

                console.log("📦 [REGULAR_PAYPAL_APPROVE] Processing payment and creating order in database...");
                processPaypalPayment(order.id, order);
              } catch (error) {
                console.error("❌ [REGULAR_PAYPAL_APPROVE] Failed to capture payment:", error);
                console.error("❌ [REGULAR_PAYPAL_APPROVE] Error details:", error.message);
                swal({
                  icon: "error",
                  title: "Payment Capture Failed",
                  text: "Failed to capture payment. Please try again.",
                });
              }
            },

            onError: (err) => {
              console.error("❌ [REGULAR_PAYPAL_ERROR] === PAYPAL ERROR OCCURRED ===");
              console.error("❌ [REGULAR_PAYPAL_ERROR] Timestamp:", new Date().toISOString());
              console.error("❌ [REGULAR_PAYPAL_ERROR] Error object:", err);
              console.error("❌ [REGULAR_PAYPAL_ERROR] Error message:", err.message);
              console.error("❌ [REGULAR_PAYPAL_ERROR] Error name:", err.name);

              swal({
                icon: "error",
                title: "PayPal Checkout Failed",
                text: err.message || "Please try again later.",
              });
            },

            onCancel: (data) => {
              console.log("⚠️ [REGULAR_PAYPAL_CANCEL] === CUSTOMER CANCELLED PAYMENT ===");
              console.log("⚠️ [REGULAR_PAYPAL_CANCEL] Timestamp:", new Date().toISOString());
              console.log("⚠️ [REGULAR_PAYPAL_CANCEL] PayPal data:", data);
              console.log("⚠️ [REGULAR_PAYPAL_CANCEL] Order ID:", data.orderID);
              console.log("⚠️ [REGULAR_PAYPAL_CANCEL] Cart is still saved - customer can try again");

              swal({
                icon: "warning",
                title: "Payment Cancelled",
                text: "You cancelled the PayPal payment. Your cart is still saved and you can try again.",
              });
            }
          }).render("#paypal-button-container");

          console.log("✅ [REGULAR_PAYPAL] PayPal buttons rendered successfully");
        } else {
          console.error("❌ [REGULAR_PAYPAL] PayPal SDK not loaded properly.");
        }
      });
    };

    const processPaypalPayment = (paypalOrderId, paypalOrderData = null) => {
      console.log("🔄 [PROCESS_PAYPAL] === STARTING ORDER CREATION ===");
      console.log("🔄 [PROCESS_PAYPAL] Timestamp:", new Date().toISOString());
      console.log("🔄 [PROCESS_PAYPAL] PayPal Order ID:", paypalOrderId);
      console.log("🔄 [PROCESS_PAYPAL] PayPal Order Data:", paypalOrderData);

      userLanguages.setLoading(true);
      isProcessingPayment.value = true; // Show payment processing overlay

      // Extract shipping address from PayPal if available
      let shippingFromPayPal = null;
      let payerFromPayPal = null;

      if (paypalOrderData && paypalOrderData.purchase_units && paypalOrderData.purchase_units[0]) {
        shippingFromPayPal = paypalOrderData.purchase_units[0].shipping || null;
        payerFromPayPal = paypalOrderData.payer || null;
        console.log("✅ [PROCESS_PAYPAL] Shipping from PayPal:", shippingFromPayPal);
        console.log("✅ [PROCESS_PAYPAL] Payer from PayPal:", payerFromPayPal);
      }

      // Use shipping method from props or default to "Standard" for PayPal express checkout
      const shippingMethod = props.shippingTypeName || "Standard";
      console.log("✅ [PROCESS_PAYPAL] Shipping method:", shippingMethod);

      console.log("✅ [PROCESS_PAYPAL] Shipping method validated:", props.shippingTypeName);
      const currentDate = new Date();
      let cartItems = [];
      let orderPayLoad = ref();

      if (cartData.getCartItems.length > 0) {
        cartData.getCartItems.forEach((items) => {
          cartItems.push({
            product_id: items.id,
            quantity: items.quantity,
            price: items.price,
            autoship: items.purchaseType == 2 ? "yes" : "no",
          });
        });
      }

      // Use PayPal shipping data if available, otherwise use form data
      const firstName = shippingFromPayPal?.name?.full_name?.split(' ')[0] || payerFromPayPal?.name?.given_name || props.first_name || "";
      const lastName = shippingFromPayPal?.name?.full_name?.split(' ').slice(1).join(' ') || payerFromPayPal?.name?.surname || props.last_name || "";
      const email = payerFromPayPal?.email_address || props.email || "";
      const shipAddress = shippingFromPayPal?.address?.address_line_1 || props.address1 || "";
      const shipAddress2 = shippingFromPayPal?.address?.address_line_2 || props.addres2 || "";
      const shipCity = shippingFromPayPal?.address?.admin_area_2 || props.city || "";
      const shipState = shippingFromPayPal?.address?.admin_area_1 || props.state || "";
      const shipZipcode = shippingFromPayPal?.address?.postal_code || props.zip_code || "";
      const shipCountryCode = shippingFromPayPal?.address?.country_code || (props.country == 38 ? "CA" : "US");
      const mobile = payerFromPayPal?.phone?.phone_number?.national_number || props.mobile || "";

      if (userLogin.checkIsLoggedIn) {
        orderPayLoad.value = {
          referal_id: userLogin.getReferalId,
          user_id: userLogin.getUserUserData.id,
          first_name: firstName,
          last_name: lastName,
          mobile: mobile,
          order_date: currentDate,
          completion_date: null,
          shipping_status: "Not Shipped",
          order_status: "Pending",
          total: cartData.getCartTotalPrice,
          netTotal: cartData.getCartTotalNetPrice,
          currency: props.country == 38 ? "CAD" : "USD",
          ship_address: shipAddress,
          ship_address2: shipAddress2,
          ship_city: shipCity,
          country: props.country || (shipCountryCode === "CA" ? 38 : 231),
          state: shipState,
          ship_zipcode: shipZipcode,
          shipping_method: shippingMethod,
          shipping_amount: props.shippingType || 0,
          shipping_tax_amount: cartData.getShippingTax,
          discount_amount: cartData.getDiscountTotal,
          tax_amount: cartData.getTaxTotal,
          notes: "",
          products: cartItems,
          shopping_country_code: shipCountryCode,
          discount_coupan_id: cartData.getCartCouponCodeId || "",
        };
      } else {
        orderPayLoad.value = {
          referal_id: userLogin.getReferalId,
          email: email,
          first_name: firstName,
          last_name: lastName,
          mobile: mobile,
          order_date: currentDate,
          total: cartData.getCartTotalPrice,
          netTotal: cartData.getCartTotalNetPrice,
          currency: props.country == 38 ? "CAD" : "USD",
          ship_address: shipAddress,
          ship_address2: shipAddress2,
          ship_city: shipCity,
          country: props.country || (shipCountryCode === "CA" ? 38 : 231),
          state: shipState,
          ship_zipcode: shipZipcode,
          shipping_method: shippingMethod,
          shipping_amount: props.shippingType || 0,
          shipping_tax_amount: cartData.getShippingTax,
          discount_amount: cartData.getDiscountTotal,
          tax_amount: cartData.getTaxTotal,
          notes: "",
          products: cartItems,
          shopping_country_code: shipCountryCode,
          discount_coupan_id: cartData.getCartCouponCodeId || "",
        };
      }

      const apiUrl = userLogin.checkIsLoggedIn ? props.baseURL + "orders" : props.baseURL + "guest/orders";

      console.log("📤 [PROCESS_PAYPAL] Creating order in database...");
      console.log("📤 [PROCESS_PAYPAL] API URL:", apiUrl);
      console.log("📤 [PROCESS_PAYPAL] Order payload:", orderPayLoad.value);

      axios.post(apiUrl, orderPayLoad.value)
        .then((response) => {
          console.log("✅ [PROCESS_PAYPAL] Order creation response:", response.data);

          if (response.data.error) {
            console.error("❌ [PROCESS_PAYPAL] Order creation failed:", response.data.error);
            userLanguages.setLoading(false);
            isProcessingPayment.value = false; // Hide overlay on order error
            swal({ position: "top-end", icon: "error", title: response.data.error, button: false, timer: 2500 });
          } else {
            const createdOrderId = response.data.data.order.id;
            console.log("✅ [PROCESS_PAYPAL] Order created successfully! Order ID:", createdOrderId);

            const orderPayment = {
              order_id: createdOrderId,
              authorization_key: paypalOrderId,  // Using PayPal's transaction id
            };

            console.log("💳 [PROCESS_PAYPAL] Processing PayPal payment...");
            console.log("💳 [PROCESS_PAYPAL] Payment payload:", orderPayment);

            axios.post(props.baseURL + "process-payment-paypal", orderPayment)
              .then((res) => {
                console.log("✅ [PROCESS_PAYPAL] Payment processing response:", res.data);

                if (res.data.error) {
                  console.error("❌ [PROCESS_PAYPAL] Payment processing failed:", res.data.error);
                  userLanguages.setLoading(false);
                  isProcessingPayment.value = false; // Hide overlay on payment error
                  swal({ position: "top-end", icon: "error", title: res.data.error, button: false, timer: 2500 });
                } else {
                  console.log("🎊 [PROCESS_PAYPAL] === PAYMENT COMPLETED SUCCESSFULLY ===");
                  console.log("🎊 [PROCESS_PAYPAL] Order ID:", createdOrderId);
                  console.log("🎊 [PROCESS_PAYPAL] PayPal Transaction ID:", paypalOrderId);
                  console.log("🎊 [PROCESS_PAYPAL] Success message:", res.data.message);

                  userLanguages.setLoading(false);
                  isProcessingPayment.value = false; // Hide overlay on success
                  swal({ position: "top-end", icon: "success", title: res.data.message, button: false, timer: 2500 });
                  cartData.$reset();
                  router.push({ name: "PaymentSuccess" });
                }
              })
              .catch((paymentError) => {
                console.error("❌ [PROCESS_PAYPAL] Payment processing error:", paymentError);
                console.error("❌ [PROCESS_PAYPAL] Error response:", paymentError.response?.data);
                userLanguages.setLoading(false);
                isProcessingPayment.value = false; // Hide overlay on catch error
                swal({
                  position: "top-end",
                  icon: "error",
                  title: "Payment processing failed",
                  text: paymentError.response?.data?.message || paymentError.message,
                  button: false,
                  timer: 3000
                });
              });
          }
        })
        .catch((error) => {
          console.error("❌ [PROCESS_PAYPAL] Order creation error:", error);
          console.error("❌ [PROCESS_PAYPAL] Error response:", error.response?.data);
          console.error("❌ [PROCESS_PAYPAL] Error stack:", error.stack);
          userLanguages.setLoading(false);
          isProcessingPayment.value = false; // Hide overlay on catch error
          swal({
            position: "top-end",
            icon: "error",
            title: "Order creation failed",
            text: error.response?.data?.message || error.message,
            button: false,
            timer: 3000
          });
        });
    };

    const maybeSetupPaymentRequest = async () => {
  if (!stripe.value) {
    console.error('Stripe is not loaded');
    return;
  }

  const container = document.getElementById('payment-request-button');
  if (!container) {
    console.warn('Payment Request Button container not yet rendered');
    return;
  }

  const currency = props.country == 38 ? 'CAD' : 'USD';
  const amount = Math.round(Number(cartData.getCartTotalNetPrice) * 100);

  const paymentRequestInstance = stripe.value.paymentRequest({
    country: 'US',
    currency: currency.toLowerCase(),
    total: {
      label: 'Total',
      amount,
    },
    requestPayerName: true,
    requestPayerEmail: true,
  });

  const elements = stripe.value.elements();
  const prButton = elements.create('paymentRequestButton', {
    paymentRequest: paymentRequestInstance,
    style: {
      paymentRequestButton: {
        type: 'default',
        theme: 'dark',
        height: '40px',
      },
    },
  });

  try {
    const result = await paymentRequestInstance.canMakePayment();
    console.log('canMakePayment result:', result);

    if (result) {
      await prButton.mount('#payment-request-button');
      paymentUnavailable.value = false;
      gPayaPayShippingPaymentUnavailable.value = false;
      gPayaPayAutoshipPaymentUnavailable.value = false;
    } else {
      container.style.display = 'none';
      paymentUnavailable.value = true;
      console.warn('Stripe Payment Request not available');
    }
  } catch (error) {
    console.error('Error mounting Stripe Payment Request button:', error);
  }

  // Handle payment
  paymentRequestInstance.on('paymentmethod', async (ev) => {
    try {
      isProcessingPayment.value = true; // Show payment processing overlay
      const tokenData = ev.paymentMethod.id;
      const cartItems = cartData.getCartItems.map(item => ({
        product_id: item.id,
        quantity: item.quantity,
        price: item.price,
        autoship: item.purchaseType == 2 ? 'yes' : 'no',
      }));

      const payload = {
        email: ev.payerEmail,
        first_name: ev.payerName?.split(' ')[0] || '',
        last_name: ev.payerName?.split(' ')[1] || '',
        order_date: new Date(),
        total: cartData.getCartTotalPrice,
        netTotal: cartData.getCartTotalNetPrice,
        currency,
        products: cartItems,
        shipping_method: 'Online',
        shipping_amount: 0,
        shopping_country_code: currency.toLowerCase() === 'cad' ? 'ca' : 'usa'
      };

      const res = await axios.post(`${props.baseURL}${userLogin.checkIsLoggedIn ? 'orders' : 'guest/orders'}`, payload);
      const orderId = res.data.data.order.id;

      await axios.post(`${props.baseURL}process-payment`, {
        order_id: orderId,
        authorization_key: tokenData
      });

      ev.complete('success');
      isProcessingPayment.value = false; // Hide overlay on success
      swal({ icon: 'success', title: 'Payment Successful', timer: 2000 });
      cartData.$reset();
      router.push({ name: 'PaymentSuccess' });
    } catch (err) {
      ev.complete('fail');
      isProcessingPayment.value = false; // Hide overlay on error
      swal({ icon: 'error', title: 'Payment Failed', timer: 2000 });
    }
  });
};




const validateShippingAddress = () => {
  console.log("shippingTypeName", props.shippingTypeName);
  console.log("first_name", props.first_name);
  console.log("last_name", props.last_name);
  console.log("address1", props.address1);
  console.log("city", props.city);
  console.log("state", props.state);
  console.log("zip_code", props.zip_code);
  console.log("country", props.country);
  console.log("mobile", props.mobile);
  if (!props.shippingTypeName || !props.first_name || !props.last_name || !props.address1 || !props.city || !props.state || !props.zip_code || !props.country || !props.mobile) {
      
      console.log("PayPal unavailable");
      return false;
  }
  console.log("PayPal available");
  return true;
};

const isAutoshipProductExist = () => {
  let count = 0;
  if (cartData.getCartItems.length > 0) {
    cartData.getCartItems.forEach((items) => {
      if (items.purchaseType == 2) count = 1;
    });
  }
  console.log("Autoship counting", count);
  if (count != 0) {
    
    return false;
  }
  return true;
};
    
    computed(() => {});

    const pay = () => {
      console.log("props", props);
      if (!props.shippingTypeName) {
          swal({
            position: "top-end",
            icon: "error",
            title: "Please select shipping method",
            button: false,
            timer: 2500,
          });
          return;
        }
      // Get stripe element
      const cardElement = card.value.stripeElement;
      userLanguages.setLoading(true);
      isProcessingPayment.value = true; // Show payment processing overlay
      elms.value.instance
        .createPaymentMethod("card", cardElement)
        .then((result) => {
          //alert(result);
          // Handle result.error or result.token
          console.log("result createPaymentMethod : ", result);
          if (result.error) {
            userLanguages.setLoading(false);
            isProcessingPayment.value = false; // Hide overlay on error
            swal({
              position: "top-end",
              icon: "error",
              title: result.error.message,
              button: false,
              timer: 1500,
            });
          } else {
            const toketData = {
              token: result.paymentMethod.id,
            };

            let tokenData = result.paymentMethod.id;
            // Create Order Id

            const UserData = userLogin.getUserUserData;
            const currentDate = new Date();
            let cartItems = [];
            let orderPayLoad = ref();
            if (cartData.getCartItems.length > 0) {
              cartData.getCartItems.forEach((items) => {
                cartItems.push({
                  product_id: items.id,
                  quantity: items.quantity,
                  price: items.price,
                  autoship: items.purchaseType == 2 ? "yes" : "no",
                });
              });

              console.log("cartData.getCartItems.length", cartItems);
            }

            if (userLogin.checkIsLoggedIn) {
              orderPayLoad.value = {
                referal_id: userLogin.getReferalId, //userLogin.getReferalId,
                user_id: UserData.id,
                first_name: props.first_name,
                last_name: props.last_name,
                mobile: props.mobile,
                order_date: currentDate,
                completion_date: null,
                shipping_status: "Not Shipped",
                order_status: "Pending",
                total: cartData.getCartTotalPrice,
                netTotal: cartData.getCartTotalNetPrice,
                currency: props.country == 38 ? "CAD" : "USD",
                ship_address: props.address1,
                ship_address2: props.addres2,
                ship_city: props.city,
                country: props.country,
                state: props.state,
                ship_zipcode: props.zip_code,
                shipping_method: props.shippingTypeName,
                shipping_amount: cartData.getShippingRate,
                shipping_tax_amount:cartData.getShippingTax,
                discount_amount: cartData.getDiscountTotal,
                tax_amount: cartData.getTaxTotal,
                notes: "",
                products: cartItems,
                shopping_country_code: userLogin.getUserCountry == "Canada" ? "CA" : "US",
                discount_coupan_id: cartData.getCartCouponCodeId
                  ? cartData.getCartCouponCodeId
                  : "",
              };
            } else {
              orderPayLoad.value = {
                referal_id: userLogin.getReferalId,
                email: props.email,
                first_name: props.first_name,
                last_name: props.last_name,
                mobile: props.mobile,
                order_date: currentDate,
                total: cartData.getCartTotalPrice,
                shopping_country_code: userLogin.getUserCountry == "Canada" ? "CA" : "US",
                netTotal: cartData.getCartTotalNetPrice,
                currency: props.country == 38 ? "CAD" : "USD",
                ship_address: props.address1,
                ship_address2: props.addres2,
                ship_city: props.city,
                country: props.country,
                state: props.state,
                ship_zipcode: props.zip_code,
                shipping_method: props.shippingTypeName,
                shipping_amount: cartData.getShippingRate,
                shipping_tax_amount:cartData.getShippingTax,
                discount_amount: cartData.getDiscountTotal,
                tax_amount: cartData.getTaxTotal,
                notes: "",
                products: cartItems,
                discount_coupan_id: cartData.getCartCouponCodeId
                  ? cartData.getCartCouponCodeId
                  : "",
              };
            }
            let apiUrl = "";
            if (userLogin.checkIsLoggedIn) {
              apiUrl = props.baseURL + "orders";
              console.log("payment checkIsLoggedIn ", apiUrl);
            } else {
              apiUrl = props.baseURL + "guest/orders";
              console.log("payment checkIsLoggedIn ", apiUrl);
            }
            console.log("apiUrl login ", apiUrl);
            axios
              .post(apiUrl, orderPayLoad.value)
              .then((response) => {
                console.log("response trnasate :", response.data);

                if (response.data.error) {
                  userLanguages.setLoading(false);
                  isProcessingPayment.value = false; // Hide overlay on order error
                  swal({
                    position: "top-end",
                    icon: "error",
                    title: response.data.error,
                    button: false,
                    timer: 2500,
                  });
                } else {
                  let orderPayment = {
                    order_id: response.data.data.order.id,
                    authorization_key: tokenData,
                  };
                  axios
                    .post(props.baseURL + "process-payment", orderPayment)
                    .then((response) => {
                      console.log("response trnasate :", response.data);

                      if (response.data.error) {
                        userLanguages.setLoading(false);
                        isProcessingPayment.value = false; // Hide overlay on payment error
                      } else {
                        swal({
                          position: "top-end",
                          icon: "success",
                          title: response.data.message,
                          button: false,
                          timer: 2500,
                        });
                        userLanguages.setLoading(false);
                        isProcessingPayment.value = false; // Hide overlay on success
                        cartData.$reset();
                        router.push({ name: "PaymentSuccess" });
                      }

                      //translationText.value = response.data;
                    })
                    .catch((error) => {
                      userLanguages.setLoading(false);
                      isProcessingPayment.value = false; // Hide overlay on catch error
                      console.error("Error fetching data:", error);
                    });
                }
              })
              .catch((error) => {
                userLanguages.setLoading(false);
                isProcessingPayment.value = false; // Hide overlay on catch error
                console.error("Error fetching data:", error);
              });
          }

          
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    };

    return {
      stripeKey,
      stripeLoaded,
      instanceOptions,
      elementsOptions,
      cardOptions,
      cardCvcOptions,
      cardNumberOptions,
      cardExpiryOptions,
      card,
      elms,
      pay,
      selectedPaymentMethod,
      paymentUnavailable,
      paypalPaymentUnavailable,
      paypalAutoshipPaymentUnavailable,
      gPayaPayAutoshipPaymentUnavailable,
      gPayaPayShippingPaymentUnavailable,
      showCheckoutMsg,
      isProcessingPayment
    };
  },
});
</script>

<style>
.payment-options .form-check-label img {
  height: 25px;
  width: auto;
  padding: 2px;
}
.payment-information .alert {
  width: 100% !important;
}
.payment-options-new{
    padding: 20px 0px !important;
    display: inline-block !important;
}
.payment-options-new .form-check-inline {
    width: 50% !important;
    margin-bottom: 10px !important;
    display: inline-flex;
    gap: 5px;
    align-items: center;
}
.payment-options-new .form-check-label img {
    height: 41px !important;
    width: 252px !important;
    padding: 0 !important;
}
.payment-options-new .form-check-inline .form-check-input{
    margin-top: 0px !important;
}
.checkout-process .options-highlited-msg {
  font-size: 15px !important;
    text-align: center !important;
    color: #000 !important;
}

/* Payment Processing Overlay */
.payment-processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(3px);
}

.payment-processing-content {
  background: white;
  padding: 40px 60px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.payment-processing-content h3 {
  margin: 20px 0 15px 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.payment-processing-content .warning-message {
  color: #d9534f;
  font-size: 16px;
  line-height: 1.6;
  margin: 20px 0 0 0;
  padding: 15px;
  background-color: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 8px;
  font-weight: 500;
}

.payment-processing-content .warning-message i {
  font-size: 20px;
  margin-right: 8px;
  vertical-align: middle;
  color: #d9534f;
}

/* Spinner Animation */
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .payment-processing-content {
    padding: 30px 40px;
    margin: 0 20px;
  }

  .payment-processing-content h3 {
    font-size: 20px;
  }

  .payment-processing-content .warning-message {
    font-size: 14px;
  }
}
</style>
